import { observer } from 'mobx-react';
import { promobannerStore } from '../../store/promobannerStore';
import { localeStore } from 'src/mobx/localesStore';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text from '~/view/components/Text/Text';
import './style.scss';

export const PromobannerLink = observer(() => {
  const onChangeLink = (value: string | undefined) => {
    promobannerStore.changePromobanner({ link: value }, true);
  };

  return (
    <div className="promobanner-link mr-4">
      <Text type="block-header" text="ksk_url_placeholder" required />
      <Input
        value={promobannerStore.promobanner.link}
        onChangeValue={onChangeLink}
        validation={{ isValid: promobannerStore.isValid.target }}
        placeholder={localeStore.t('ksk_url_placeholder')}
        contentClassName="promobanner-link__input mt-2"
      />
    </div>
  );
});
